import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { SectionHeader } from "./GameDebugInfoUI";
import { BorderPrimary, GUIHeadlineSuffix, GUISubBox, GUIHeadline } from "../GameUIElements";
import { soundCache } from "../../../../stores/SoundCache";
const ScrollContainer = styled(GUISubBox).withConfig({
  displayName: "SoundInstanceDebugUI__ScrollContainer",
  componentId: "sc-106qmrj-0"
})(["display:flex;flex-direction:column;height:100%;overflow-y:scroll;width:100%;"]);
const SectionHeaderLabel = styled.label.withConfig({
  displayName: "SoundInstanceDebugUI__SectionHeaderLabel",
  componentId: "sc-106qmrj-1"
})(["display:flex;flex-direction:row;"]);
const ItemContainer = styled.div.withConfig({
  displayName: "SoundInstanceDebugUI__ItemContainer",
  componentId: "sc-106qmrj-2"
})(["display:flex;flex-direction:column;margin:2px;padding:2px;", ""], BorderPrimary);
const AdjustedScrollContainer = styled(ScrollContainer).withConfig({
  displayName: "SoundInstanceDebugUI__AdjustedScrollContainer",
  componentId: "sc-106qmrj-3"
})(["max-height:245px;"]);
export const SoundInstanceDebugUI = () => {
  const {
    t
  } = useTranslation();
  const [activeInstances, setActiveInstances] = useState([]);
  useEffect(() => {
    const intervalId = setInterval(() => {
      const allInstances = new Array();

      for (const [name, sound] of soundCache.allSounds) {
        for (const instance of sound.instances) {
          allInstances.push({
            name,
            volume: instance.volume * sound.volume
          });
        }
      }

      setActiveInstances(allInstances);
    }, 100);
    return () => clearInterval(intervalId);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(SectionHeaderLabel, null, /*#__PURE__*/React.createElement(GUIHeadline, null, t("game.debug_headline_active_sound_instances"), " "), /*#__PURE__*/React.createElement(GUIHeadlineSuffix, null, "(" + activeInstances.length + ")"))), /*#__PURE__*/React.createElement(AdjustedScrollContainer, null, activeInstances.map((instance, index) => /*#__PURE__*/React.createElement(ItemContainer, {
    key: index
  }, instance.name, /*#__PURE__*/React.createElement("progress", {
    value: instance.volume,
    max: 1
  })))));
};